import CloseActionButton from '../../../components/kit/action-button/CloseActionButton';
import Button from '../../../components/kit/button/Button';
import Logo from '../../../components/kit/logo/Logo';
import Text from '../../../components/kit/text/Text';
import styles from './WelcomeScreen.module.css';

type WelcomeScreenProps = {
  isVisible: boolean;
  onClose: () => void;
  onContinue: () => void;
};

const WelcomeScreen = ({
  isVisible,
  onClose,
  onContinue,
}: WelcomeScreenProps) => {
  return (
    <div className={isVisible ? styles.wrapper : styles.hidden}>
      <div className={styles.header}>
        <CloseActionButton onClose={onClose} />
      </div>
      <div className={styles.content}>
        <Logo type='icon' style={{ width: '99px', marginBottom: '20px' }} />
        <Text weight='bold' size='x-large' tag='h1'>
          Welcome to Vydura Buddy!
        </Text>
        <Text size='medium'>
          We have a few questions to ask to get you started.
        </Text>
        <div className={styles.footer}>
          <Button
            type='primary'
            width='full-width'
            onClick={onContinue}
            style={{ marginLeft: 0 }}
          >
            Start
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
